module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "editor",
    staticClass: "form-control",
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "readonly": _vm._readonly
    }
  }), _vm._v(" "), _c('div', [(!_vm._readonly) ? _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reformat
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18n.fr('action.reformat_code')) + "\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.err) ? _c('div', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "ti ti-alert"
  }), _vm._v(_vm._s(_vm.err.message))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d9c1538e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-json.vue
// module id = 534
// module chunks = 55